<script lang="ts">
    import { _ } from 'svelte-i18n';
    import MenuWrapper from './../MenuWrapper.svelte';
    import IconArrowRight from '../../../shared/Icons/IconArrowRight.svelte';
    import { menuContext } from './MenuContextStore';
    import { clickOutside } from '../../../utilities/clickOutside.js';
    import MenuWrapper2 from './MenuWrapper2.svelte';
    import { afterUpdate } from 'svelte';

    export let anchorVisible: boolean = true;
    // export let isDropdownOpen: boolean = true; // default state (dropdown close)
    let container: HTMLDivElement;

    // pos is cursor position when right click occur
    let pos: { x: number; y: number } = { x: 0, y: 0 };
    // menu is dimension (height and width) of context menu
    let menu: { h: number; w: number } = { h: 0, w: 0 };
    // browser/window dimension (height and width)
    let browser: { h: number; w: number } = { h: 0, w: 0 };
    // showMenu is state of context-menu visibility
    let showMenu = false;
    // to display some text
    let content: HTMLDivElement;
    let timeoutForIgnoreClickOutside = null;
    let ignoreClickOutside: boolean = true;

    function getContextMenuDimension(node) {
        // This function will get context menu dimension
        // when navigation is shown => showMenu = true
        let height = node.offsetHeight;
        let width = node.offsetWidth;
        menu = {
            h: height,
            w: width,
        };
    }

    const handleDropdownClick = () => {
        console.log('handleDropdownClick');
        // isDropdownOpen = !isDropdownOpen; // togle state on click
        $menuContext.isOpen = !$menuContext.isOpen;
    };

    const handleClickOutside = () => {
        if (ignoreClickOutside) {
            // console.log(
            //     'MenuContextParent, handleClickOutside, ignoreClickOutside',
            //     ignoreClickOutside
            // );
            return;
        }
        // console.log('MenuContextParent, handleClickOutside, close menu', ignoreClickOutside);
        $menuContext.isOpen = false;
    };

    // $: {
    afterUpdate(() => {
        // console.log('MenuContextParent, afterUpdate1, ignoreClickOutside', ignoreClickOutside);
        ignoreClickOutside = true;
        setTimeout(() => {
            // console.log('MenuContextParent, afterUpdate2, ignoreClickOutside', ignoreClickOutside);
            ignoreClickOutside = false;
        }, 100);
        if ($menuContext.isOpen) {
            if (container) {
                // check if container is out of the screen
                // console.log('container, top', container.getBoundingClientRect().top);
                // console.log('container, bottom', container.getBoundingClientRect().bottom);
                // console.log('container, height', container.getBoundingClientRect().height);
                // console.log('container, width', container.getBoundingClientRect().width);
                // console.log('window.innerHeight', window.innerHeight);
                // console.log('window.innerWidth', window.innerWidth);

                // not to high
                if (
                    container.getBoundingClientRect().top +
                        container.getBoundingClientRect().height >
                    window.innerHeight
                ) {
                    container.style.top = 'auto';
                    container.style.bottom = '0';
                }

                // not to right
                if (
                    container.getBoundingClientRect().left +
                        container.getBoundingClientRect().width >
                    window.innerWidth
                ) {
                    container.style.left = 'auto';
                    container.style.right = '0';
                }
                // not to left
                if (container.getBoundingClientRect().left < 0) {
                    container.style.left = '0';
                }

                // not too low
                if (container.getBoundingClientRect().bottom > window.innerHeight) {
                    container.style.top = 'auto';
                    container.style.bottom = '0';
                }
            } else {
                console.warn('container is not defined, Parent', $menuContext.isOpen);
            }
        }
    });

    // $: {
    //     console.log('MenuContextParent', $menuContext);
    //     // isDropdownOpen = $menuContext.isOpen;
    // }

    let menuMode: string = 'menu';

    $: { menuMode = $menuContext.getMode(); }
</script>

{#if $menuContext.isOpen}
    <div
        class="menu-list"
        class:tooltip={menuMode === 'tooltip'}
        class:menu={menuMode === 'menu'}
        use:getContextMenuDimension
        bind:this={container}
        style:visibility={$menuContext.isOpen ? 'visible' : 'hidden'}
        style={`top: ${$menuContext.y}px; left: ${$menuContext.x}px;`}
        use:clickOutside
        on:click_outside={handleClickOutside}
        autofocus
    >
        {#each $menuContext.getVisibleActions() as action}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div
                class="menu-list-item"
                class:disabled={action.disabled}
                on:click={() => {
                    console.log('click', action.label, action.onClick);
                    if (action.disabled) return;
                    if (action.subMenu !== null && typeof action.subMenu !== 'undefined') {
                        action.subMenuIsOpen = !action.subMenuIsOpen;
                        //                        console.log('toggle subMenu', action.subMenuIsOpen);
                        action = action;
                        $menuContext = $menuContext;
                    } else if (typeof action.onClick === 'function') {
                        //isDropdownOpen = action.onClick() === true;
                        // console.log('MenuContextParent, function');
                        $menuContext.isOpen = action.onClick() === true;
                        $menuContext = $menuContext;
                    }
                }}
            >
                {#if $menuContext.isAnyIcon()}
                    <div class="menu-list-item-icon">
                        {#if action.icon}
                            {#if action.iconColorComponent}
                                <svelte:component this={action.iconColorComponent}>
                                    <svelte:component this={action.icon} scale={0.7} />
                                </svelte:component>
                            {:else}
                                <svelte:component this={action.icon} scale={0.7} />
                            {/if}
                        {/if}
                    </div>
                {/if}
                <div class="menu-list-item-label">
                    {@html $_(action.label)}
                </div>
                {#if action.subMenu !== null}
                    <div>
                        <div class="menu-list-item-icon-more">
                            <IconArrowRight scale={0.7} />
                        </div>
                        {#if action.subMenuIsOpen}
                            <MenuWrapper2
                                menu={action.subMenu}
                                isDropdownOpen={true}
                                onClick={() => {
                                    //isDropdownOpen = false;
                                    //console.log('MenuContextParent, close menu');
                                    $menuContext.isOpen = false;
                                }}
                            />
                        {/if}
                    </div>
                {/if}
            </div>
        {/each}
    </div>
{/if}

<style>
    :root {
        --menu-background: #6c6b6a;
        --menu-color: #ffffff;
    }
    .menu-list {
        z-index: 5000;
        padding: 8px;
        background-color: white;
        color: black;
        border-radius: 6px;
        font-size: 13px;
        position: absolute;
        /*right: 0;*/
        /*left: 0;*/
        /*top: 35px;*/
        box-shadow: -1px 11px 31px -10px rgba(0, 0, 0, 0.75);
        min-width: 220px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        row-gap: 0;
    }
    .menu-list .menu-list-item {
        list-style: none;
        /*color: white;*/
        min-width: 130px;
        cursor: pointer;
        border-radius: 3px;
        padding: 6px 14px;
        border: 0;
        background-color: inherit;
        text-align: left;
        display: flex;
        flex-direction: row;
        align-items: center;
        column-gap: 3px;
    }
    .menu-list .menu-list-item-label {
        font-weight: 400;
        flex: 1;
    }
    .menu-list .menu-list-item-icon {
        min-width: 30px;
    }
    .menu-list .menu-list-item-icon-more {
        min-width: 30px;
    }
    .menu-list .menu-list-item:hover {
        /*background-color: var(--menu-color);*/
        background-color: var(--main-selected-background);
        /*color: var(--menu-background);*/
    }
    .dropdown {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-weight: 500;
    }
    .clickable {
        cursor: pointer;
    }
    .menu-list.menu .menu-list-item.disabled {
        opacity: 0.3;
        cursor: default;
    }
    .menu-list.tooltip .menu-list-item.disabled {
        opacity: 1;
        cursor: default;
    }
</style>
